import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {

copyrightYear = new Date().getFullYear();
  constructor() { }

  ngOnInit() {
  }

  openCufiAbout() {
    window.open('https://www.cufi.org/impact/about-us/', '_blank');
  }

  openCufiOnCampus() {
    window.open('https://www.cufioncampus.org/', '_blank');
  }

  openCTALink() {
    window.open('https://cufi.org/donate');
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/footer/footer.component.ts